module.exports = __webpack_public_path__ + "img/pull-request.82a40288.svg";